module.exports = __webpack_public_path__ + "static/token-governance-c33306c4409015ad2d116c566167c294.svg";